enum OmnichannelReportRequest {
  Total = 'OMNICHANNEL_TOTAL',

  DateDelivery = 'OMNICHANNEL_BID_DAY_DELIVERY',
  WeekDelivery = 'OMNICHANNEL_WEEK_DELIVERY',
  MonthDelivery = 'OMNICHANNEL_MONTH_DELIVERY',
  QuarterDelivery = 'OMNICHANNEL_QUARTER_DELIVERY',
  ChannelDelivery = 'OMNICHANNEL_CHANNEL_DELIVERY',
  DeviceDelivery = 'OMNICHANNEL_DEVICE_TYPE_DELIVERY',
  AdvertiserDelivery = 'OMNICHANNEL_ADVERTISER_DELIVERY',
  CampaignDelivery = 'OMNICHANNEL_CAMPAIGN_DELIVERY',
  PlacementDelivery = 'OMNICHANNEL_PLACEMENT_DELIVERY',
  CreativeDelivery = 'OMNICHANNEL_CREATIVE_DELIVERY',
  PublisherDelivery = 'OMNICHANNEL_PUBLISHER_DELIVERY',
  DayOfWeekDelivery = 'OMNICHANNEL_DAY_OF_WEEK_DELIVERY',
  DaypartDelivery = 'OMNICHANNEL_DAYPART_DELIVERY',
  DealsDelivery = 'OMNICHANNEL_DEALS_DELIVERY',
  ContentNetworkDelivery = 'OMNICHANNEL_CONTENT_NETWORK_DELIVERY',
  ContentChannelDelivery = 'OMNICHANNEL_CONTENT_CHANNEL_DELIVERY',

  StateDelivery = 'OMNICHANNEL_STATE_DELIVERY',
  DmaDelivery = 'OMNICHANNEL_DMA_DELIVERY',
  CountyDelivery = 'OMNICHANNEL_COUNTY_DELIVERY',
  ZipDelivery = 'OMNICHANNEL_ZIP_DELIVERY',
  CongressionalDelivery = 'OMNICHANNEL_CONGRESSIONAL_DELIVERY',
  CityDelivery = 'OMNICHANNEL_CITY_DELIVERY',

  DateAttribution = 'OMNICHANNEL_BID_DAY_ATTRIBUTION',
  WeekAttribution = 'OMNICHANNEL_WEEK_ATTRIBUTION',
  MonthAttribution = 'OMNICHANNEL_MONTH_ATTRIBUTION',
  QuarterAttribution = 'OMNICHANNEL_QUARTER_ATTRIBUTION',
  ChannelAttribution = 'OMNICHANNEL_CHANNEL_ATTRIBUTION',
  DeviceAttribution = 'OMNICHANNEL_DEVICE_TYPE_ATTRIBUTION',
  AdvertiserAttribution = 'OMNICHANNEL_ADVERTISER_ATTRIBUTION',
  CampaignAttribution = 'OMNICHANNEL_CAMPAIGN_ATTRIBUTION',
  PlacementAttribution = 'OMNICHANNEL_PLACEMENT_ATTRIBUTION',
  CreativeAttribution = 'OMNICHANNEL_CREATIVE_ATTRIBUTION',
  PublisherAttribution = 'OMNICHANNEL_PUBLISHER_ATTRIBUTION',
  DayOfWeekAttribution = 'OMNICHANNEL_DAY_OF_WEEK_ATTRIBUTION',
  DaypartAttribution = 'OMNICHANNEL_DAYPART_ATTRIBUTION',
  DealsAttribution = 'OMNICHANNEL_DEALS_ATTRIBUTION',

  StateAttribution = 'OMNICHANNEL_STATE_ATTRIBUTION',
  DmaAttribution = 'OMNICHANNEL_DMA_ATTRIBUTION',
  CountyAttribution = 'OMNICHANNEL_COUNTY_ATTRIBUTION',
  ZipAttribution = 'OMNICHANNEL_ZIP_ATTRIBUTION',
  CongressionalAttribution = 'OMNICHANNEL_CONGRESSIONAL_ATTRIBUTION',
  CityAttribution = 'OMNICHANNEL_CITY_ATTRIBUTION',

  ZipByCodes = 'OMNICHANNEL_ZIP_BY_CODES',
  DmaBoundaries = 'OMNICHANNEL_DMA_BOUNDARIES',
  StateBoundaries = 'OMNICHANNEL_STATE_BOUNDARIES',
  CountyBoundaries = 'OMNICHANNEL_COUNTY_BOUNDARIES',
  CongressionalBoundaries = 'OMNICHANNEL_CONGRESSIONAL_BOUNDARIES',
  CityBoundaries = 'OMNICHANNEL_CITY_BOUNDARIES',
}

export default OmnichannelReportRequest;
